import React, { FC } from "react";
import { Table, Button } from "antd";
import { Form } from "@/components/YhFormBox";
import { YHModal } from "@/components/YHModal";
import { ColumnsType } from "antd/lib/table";
import { YhBox } from "@/components/YhBox";
import { RouterParamType } from "@/model/navModel";
import { useShipmentDetailModel } from "../shipmentDetailModel";
import { IShipmentBoxInfo, IShipmentTabEnum } from "@/views/shipment/shimentTypes";
import { YhFormItemsBox } from "@/components/YhFormBox";
import { IYhFormItemsBox, FormItemTypeEnum, IForm } from "@/components/YhFormBox/Types";


export const BoxDetailDialog: FC<RouterParamType> = ({ id, mode }) => {
    const { boxDetailDialog: visible, setBoxDetailDialog, setTabActive, editBoxList, editFormVal } = useShipmentDetailModel(({ boxDetailDialog, editBoxList, editFormVal }) => [boxDetailDialog, editBoxList, editFormVal])

    const onCancel = () => {
        setBoxDetailDialog(false);
    };


    const FormBoxItem: IYhFormItemsBox = {
        title: " ",
        style: { padding: "10px 0 0 0", marginBottom: "10px", width: "100%" },
        contentClass: "pr-2",
        disabled: true,
        items: [
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "集装箱数",
                fieldName: "containerNum",
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "件数",
                fieldName: "number",
            }
        ]
    };

    const fromConfig: IForm = {
        labelCol: { span: 8 },
        labelAlign: "right",
        formValues: editFormVal,
    }

    const columns = [
        {
            title: '序号',
            width: 50,
            align: "center",
            fixed: "left",
            dataIndex: "totalTxt",
            render: (t: any, r: any, i: number) => <>{t ? t : i + 1}</>
        }, {
            title: '集装箱号',
            width: 160,
            dataIndex: 'containerCode',
        }, {
            title: '铅封号',
            width: 160,
            dataIndex: 'sealNum',
        }, {
            title: '司机',
            width: 160,
            dataIndex: 'driver',
        }, {
            title: '联系电话',
            width: 160,
            dataIndex: 'phone',
        }, {
            title: '车牌号',
            width: 160,
            dataIndex: 'licensePlate',
        }, {
            title: '日期',
            width: 160,
            dataIndex: 'date',
            render: (text: any) => text instanceof Object ? text.format('YYYY-MM-DD') : text
        },
    ];


    const rightChildren = <Button
        className="mr-5"
        type="link"
        shape="round"
        onClick={() => { setTabActive(IShipmentTabEnum.FILES) }}
    >查看附件</Button>

    return <YHModal
        visible={visible}
        okText="确认"
        onOk={onCancel}
        onCancel={onCancel}
        title="装柜信息"
        width={1000}
        bodyHeight={700}
        showFooter={true}
    >
        <Form {...fromConfig}>
            <YhFormItemsBox {...FormBoxItem} />
        </Form>
        <YhBox title=" " style={{ marginBottom: "10px", width: "100%" }} rightChildren={rightChildren}>
            <Table
                columns={columns as ColumnsType<IShipmentBoxInfo>}
                dataSource={editBoxList}
                pagination={false}
                scroll={{ x: 'max-content', y: 500 }}
            />
        </YhBox>
    </YHModal>
}